module.exports = __webpack_public_path__ + "h5/img/recruit_img.ed62108b.png";